function convert2html(str: string) {
  try {
    const reg1 = /#\s(Explanation|Answer):|## Step\s?\d:?/g;
    str = str.replace(reg1, (s: string) => {
      s = s.replace(/#/g, '');
      if (/Step/.test(s)) {
        return `<h5>${s.replace('<br />', '')}</h5>`;
      } else {
        return `<h4>${s}</h4>`;
      }
    });
    str = str.replace(/<User Input>/g, '');
    const reg2 = /#{1,3}\d?\s.+?:/g;
    str = str.replace(reg2, (s: string) => {
      return `<p>${s.replace(/#|\n/g, '')}</p>`;
    });
    str = str.replace(/#/g, '');
    return str;
  } catch (e) {
    return str;
  }
}
export default convert2html;
